module.exports = __webpack_public_path__ + "static/stielwindlicht-blau.d1091139.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbs/stielwindlicht-blau.jpg
// module id = 560
// module chunks = 35783957827783